<script>
export default {
  components: {},
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="row flex justify-between align-end">
    <div class="flex align-end">
      <div class="title">{{ label }}</div>
      <div class="items flex align-end">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.row {
  .title {
    width: 100px;
    color: var(--color-text-1);
  }
  .items {
    &>* {
      width: 200px;
    }
  }
}
</style>